import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedViewFilter from 'mini-mail-list-store/lib/utils/getFocusedViewFilter';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import type NativeAdPlacement from '../store/schema/NativeAdPlacement';
import { getIsShowMultipleAds } from './getIsShowMultipleAds';
import { getNativeAdShowStatus, type NativeAdUserFlight } from 'mini-mail-nativead-userchecker';

/**
 * This util returns the index of Default Ad and Floating Ad in the Mail List according to current view (focused, primary, other).
 * @returns [firstIndex, secondIndex] where firstIndex is the index of Floating Ad (multiple ads)/ Fixed ad(Single ad) and secondIndex is the index of Fixed Ad.
 */

export const getAdIndexName = () => {
    let firstIndex: NativeAdPlacement;
    let secondIndex: NativeAdPlacement;
    const isShowMultipleAd = getIsShowMultipleAds();

    if (!isFocusedInboxEnabled()) {
        firstIndex = isShowMultipleAd ? 'InboxFloating' : 'InboxFixed';
        secondIndex = 'InboxFixed';
    } else if (getFocusedViewFilter() === 0) {
        firstIndex = 'FocusPivot';
    } else {
        firstIndex = isShowMultipleAd ? 'OtherPivotFloating' : 'OtherPivotFixed';
        secondIndex = 'OtherPivotFixed';
    }
    if (getNativeAdShowStatus() === 2) {
        firstIndex = 'MiniHeader';
    }
    return [firstIndex, secondIndex];
};
